import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=12b8697a&scoped=true&"
import script from "./image-input.vue?vue&type=script&lang=ts&"
export * from "./image-input.vue?vue&type=script&lang=ts&"
import style0 from "./image-input.vue?vue&type=style&index=0&id=12b8697a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8697a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VImg,VOverlay})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b8697a')) {
      api.createRecord('12b8697a', component.options)
    } else {
      api.reload('12b8697a', component.options)
    }
    module.hot.accept("./image-input.vue?vue&type=template&id=12b8697a&scoped=true&", function () {
      api.rerender('12b8697a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/image-input.vue"
export default component.exports